import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	userCard: {
		padding: "8px"
	},
	textContainer: {
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	nameText: {
		fontWeight: 600,
		fontSize: "16px"
	},
	userCardIconButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		fontSize: "20px"
	},
	roleChip: {
		color: colors.gray[700]
	},
	teamChip: {
		background: colors.gray[50]
	},
	activeChip: {
		background: colors.green[100],
		color: colors.green[700],
		cursor: "pointer",
		fontWeight: 600,
		"&:hover": {
			background: colors.green[200]
		}
	},
	popoverContent: {
		minWidth: "220px",
		maxWidth: "300px",
		padding: "8px 0"
	},
	popoverItem: {
		display: "flex",
		flexDirection: "column",
		padding: "8px 16px",
		gap: "2px"
	},
	popoverItemBorder: {
		borderTop: `1px solid ${colors.gray[100]}`
	},
	popoverContactName: {
		fontWeight: 600,
		color: colors.gray[800]
	},
	popoverWaitTime: {
		color: colors.gray[500],
		marginTop: "2px"
	}
})

export default useStyles
